/*
 * Runtime accessibility patches (WCAG 2.1 AA) for theme markup that is cloned or
 * re-rendered by JS, and for third-party widgets (Rebuy) we cannot edit.
 * Every patch is idempotent and only ADDS missing semantics; nothing is removed
 * except invalid ARIA (aria-level on links, slick role=option around links).
 */
(function () {
  'use strict';
  var uid = 0;
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  // Only write when the value changes, so the MutationObserver below cannot loop.
  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function ensureId(el, prefix) {
    if (!el) return null;
    if (!el.id || document.querySelectorAll('[id="' + el.id + '"]').length > 1) el.id = prefix + '-' + (++uid);
    return el.id;
  }

  /* 1. Mobile nav submenu toggles: name, state, controls, Space key */
  function patchNavToggles(root) {
    var toggles = root.querySelectorAll('a.navigation__children-toggle.none-desktop, a.navigation__children-toggle.mobile-toggle');
    for (var i = 0; i < toggles.length; i++) {
      var t = toggles[i], item = t.parentElement;
      if (!item) continue;
      var link = item.querySelector(':scope > .navigation__link');
      var panel = item.querySelector(':scope > .navigation__tier-2-container, :scope > .navigation__tier-3-container');
      setAttr(t, 'role', 'button');
      setAttr(t, 'tabindex', '0');
      if (!t.getAttribute('aria-label') && link) {
        // Own text only: the link also holds an icon whose <desc> reads "Toggle menu"
        var own = '';
        for (var n = 0; n < link.childNodes.length; n++) if (link.childNodes[n].nodeType === 3) own += link.childNodes[n].nodeValue;
        own = own.replace(/\s+/g, ' ').trim() || text(link);
        t.setAttribute('aria-label', 'Show ' + own + ' submenu');
      }
      if (panel) {
        // The mobile drawer is a clone of the desktop nav, so its panel ids are duplicates.
        var pid = panel.closest('.mobile-navigation-drawer') ? ensureId(panel, 'be-subnav') : (panel.id || ensureId(panel, 'be-subnav'));
        setAttr(t, 'aria-controls', pid);
      }
      setAttr(t, 'aria-expanded', item.classList.contains('navigation__item--open') ? 'true' : 'false');
      if (!t.__beKey) {
        t.__beKey = true;
        t.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); this.click(); }
        });
      }
    }
  }
  function syncNavState(item) {
    var t = item.querySelector(':scope > .navigation__children-toggle.none-desktop, :scope > .navigation__children-toggle.mobile-toggle');
    if (t) setAttr(t, 'aria-expanded', item.classList.contains('navigation__item--open') ? 'true' : 'false');
  }

  /* 2. Sticky add-to-cart bar: hidden bar must not hold keyboard focus */
  function patchStickyAtc() {
    var bar = document.getElementById('sticky-atc-bar');
    if (!bar) return;
    var hidden = bar.getAttribute('aria-hidden') === 'true';
    bar.inert = hidden;
    if (hidden) bar.setAttribute('inert', ''); else bar.removeAttribute('inert');
  }

  /* 3. Slick slideshows: role=option on slides that contain links is invalid
        (nested-interactive); slides are plain groups for AT */
  function patchSlick(root) {
    var s = root.querySelectorAll('.slick-slide[role="option"], .slick-track[role="listbox"]');
    for (var i = 0; i < s.length; i++) {
      s[i].removeAttribute('role');
      if (s[i].classList.contains('slick-slide')) { s[i].setAttribute('role', 'group'); s[i].setAttribute('aria-roledescription', 'slide'); }
    }
  }

  /* 4. Rebuy widgets */
  function productName(el) {
    var host = el.closest('[class*="product-id-"]');
    if (!host) return '';
    var title = host.querySelector('.rebuy-product-title');
    if (title && text(title)) return text(title);
    var img = host.querySelector('img[alt]');
    if (img && img.alt.trim() && !/^#(?:Type|Size)_/.test(img.alt)) return img.alt.trim();
    var m = host.className.match(/product-id-(\d+)/);
    if (m) {
      var t = document.querySelector('.rebuy-product-block.product-id-' + m[1] + ' .rebuy-product-title');
      if (t && text(t)) return text(t);
    }
    return '';
  }
  function patchRebuy(root) {
    // aria-level is only allowed with role=heading; Rebuy puts it on plain product links
    var lv = root.querySelectorAll('a[aria-level]:not([role="heading"])');
    for (var i = 0; i < lv.length; i++) lv[i].removeAttribute('aria-level');
    // Unlabeled bundle checkboxes
    var cb = root.querySelectorAll('input.rebuy-checkbox:not([aria-label]):not([aria-labelledby])');
    for (var j = 0; j < cb.length; j++) {
      var lab = cb[j].closest('label');
      if (lab && text(lab)) continue;
      var name = productName(cb[j]);
      cb[j].setAttribute('aria-label', name ? 'Include ' + name + ' in bundle' : 'Include this product in bundle');
    }
    var named = root.querySelectorAll('#rebuy-cart input[type="checkbox"][aria-label], .rebuy-widget input[type="checkbox"][aria-label]');
    for (var k = 0; k < named.length; k++) {
      var raw = named[k].getAttribute('aria-label');
      if (/<[^>]+>/.test(raw)) setAttr(named[k], 'aria-label', raw.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ').trim());
    }
  }

  function patchTokenImageAlts(root) {
    var images = root.querySelectorAll('img[alt^="#Type_"], img[alt^="#Size_"]');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      var host = img.closest('.rebuy-product-block, .rebuy-cart__flyout-item, li, .product-detail');
      if (!host) continue;
      var title = host.querySelector('.rebuy-product-title, .rebuy-cart__flyout-item-title, h5 a, h5, h1');
      var name = text(title).replace(/^View\s+/, '');
      if (!name) continue;
      var variant = img.alt.replace(/\s*#(?:Type|Size)_/g, ', ').replace(/^,\s*/, '').replace(/\s+/g, ' ').trim();
      setAttr(img, 'alt', name + (variant ? ', ' + variant : ''));
    }
  }

  function patchCartName() {
    var trigger = document.getElementById('smartCartTrigger');
    if (!trigger) return;
    var label = text(trigger.querySelector('.cart-link__label')) || 'Cart';
    var countText = text(trigger.querySelector('.cart-link__count'));
    var match = countText.match(/\d+/);
    var count = match ? match[0] : '0';
    setAttr(trigger, 'aria-label', label + ' (' + count + ')');
  }

  var mobileNavTrigger = null;
  function mobileDrawer() { return document.querySelector('.mobile-navigation-drawer'); }
  function mobileNavOpen() { return document.body.classList.contains('reveal-mobile-nav'); }
  function syncMobileDrawer() {
    var drawer = mobileDrawer();
    if (!drawer) return;
    var open = mobileNavOpen();
    if (drawer.inert === open) drawer.inert = !open;
    setAttr(drawer, 'aria-hidden', open ? 'false' : 'true');
    if (open) setAttr(drawer, 'aria-modal', 'true');
    else drawer.removeAttribute('aria-modal');
    var trigger = document.querySelector('#pageheader .mobile-nav-toggle');
    if (trigger) setAttr(trigger, 'aria-expanded', open ? 'true' : 'false');
  }
  function mobileNavItems(drawer) {
    var all = drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var items = [];
    for (var i = 0; i < all.length; i++) {
      var style = getComputedStyle(all[i]);
      if (!all[i].disabled && all[i].getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && all[i].tabIndex >= 0) items.push(all[i]);
    }
    return items;
  }
  function handleMobileNavClick(e) {
    var toggle = e.target.closest('.mobile-nav-toggle');
    if (!toggle) return;
    var opening = !!toggle.closest('#pageheader') && !mobileNavOpen();
    if (opening) mobileNavTrigger = toggle;
    setTimeout(function () {
      syncMobileDrawer();
      var drawer = mobileDrawer();
      if (opening && drawer && mobileNavOpen()) {
        var close = drawer.querySelector('.navigation__mobile-header .mobile-nav-toggle');
        if (close) close.focus({ preventScroll: true });
      } else if (!mobileNavOpen() && mobileNavTrigger) {
        mobileNavTrigger.focus({ preventScroll: true });
      }
    }, 30);
  }
  function handleMobileNavKeydown(e) {
    if (!mobileNavOpen()) return;
    var drawer = mobileDrawer();
    if (!drawer) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      var close = drawer.querySelector('.navigation__mobile-header .mobile-nav-toggle');
      if (close) close.click();
      return;
    }
    if (e.key !== 'Tab') return;
    var items = mobileNavItems(drawer);
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (!drawer.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
  function handleMobileNavFocus(e) {
    var drawer = mobileDrawer();
    if (mobileNavOpen() && drawer && !drawer.contains(e.target)) {
      var items = mobileNavItems(drawer);
      if (items.length) items[0].focus({ preventScroll: true });
    }
  }

  function handleSkipLinkClick(e) {
    var link = e.target.closest && e.target.closest('a.skip-link[href="#content"]');
    if (!link) return;
    var main = document.getElementById('content');
    if (!main) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    main.focus({ preventScroll: true });
    main.scrollIntoView({ block: 'start' });
  }

  /* 5. Footer Junip badge link has no text until the badge renders stars */
  function patchJunipLink(root) {
    var a = root.querySelectorAll('.custom-junip > a');
    for (var i = 0; i < a.length; i++) {
      if (text(a[i])) a[i].removeAttribute('aria-label');
      else setAttr(a[i], 'aria-label', 'Read verified customer reviews');
    }
  }

  /* 6. Third-party widgets are injected after theme load. Correct the parts of
        their host markup that remain under the storefront document's control. */
  function patchThirdPartyWidgets(root) {
    var merchantFrame = root.querySelector('#merchantwidgetiframe');
    if (merchantFrame) setAttr(merchantFrame, 'title', 'Google store quality information');

    var alia = root.querySelectorAll('[role="button"][aria-label="Spin to win"], [role="button"][aria-label^="Spin to win:"]');
    for (var i = 0; i < alia.length; i++) {
      var aliaText = text(alia[i]);
      if (aliaText) alia[i].removeAttribute('aria-label');
      else setAttr(alia[i], 'aria-label', 'Spin to win');
    }

    var reviews = root.querySelectorAll('.junip-review-carousel-item[role="button"]');
    for (var j = 0; j < reviews.length; j++) {
      var reviewText = text(reviews[j]);
      if (reviewText) reviews[j].removeAttribute('aria-label');
    }
  }

  function patchAll(root) {
    root = root || document;
    var main = document.getElementById('content');
    if (main) setAttr(main, 'tabindex', '-1');
    patchNavToggles(root); patchSlick(root); patchRebuy(root); patchTokenImageAlts(root); patchJunipLink(root); patchThirdPartyWidgets(root); patchStickyAtc(); patchCartName(); syncMobileDrawer();
  }

  var queued = false;
  function schedule() {
    if (queued) return; queued = true;
    (window.requestAnimationFrame || setTimeout)(function () { queued = false; patchAll(document); });
  }
  function start() {
    patchAll(document);
    document.addEventListener('click', handleMobileNavClick);
    document.addEventListener('click', handleSkipLinkClick, true);
    document.addEventListener('keydown', handleMobileNavKeydown, true);
    document.addEventListener('focusin', handleMobileNavFocus);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.type === 'attributes') {
          if (m.attributeName === 'class' && m.target.classList && m.target.classList.contains('navigation__item')) syncNavState(m.target);
          else if (m.target.id === 'sticky-atc-bar') patchStickyAtc();
          else if (m.attributeName === 'role' || m.attributeName === 'aria-level' || m.attributeName === 'aria-label') schedule();
        } else if (m.addedNodes && m.addedNodes.length) { schedule(); }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden', 'role', 'aria-level', 'aria-label'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
